import { cx } from '@travel/utils';
import { getPlanDataCount, getProviderDataCount } from 'favoriteList/store/providerPlan/selectors';
import { useSelector } from 'react-redux';
import styles from './totalDataCount.module.scss';

type Props = {
  isPlanList: boolean;
};

const TotalDataCount = (props: Props) => {
  const { isPlanList } = props;
  const providerDataCount = useSelector(getProviderDataCount);
  const planDataCount = useSelector(getPlanDataCount);
  const total = isPlanList ? planDataCount : providerDataCount;
  const strongText = isPlanList ? 'プラン' : '件';

  return (
    <p className={cx(styles.dataCount, isPlanList && styles.planCount)}>
      {total}
      <strong className={styles.dataText}>{strongText}</strong>
    </p>
  );
};

export default TotalDataCount;
